/**
 * @generated SignedSource<<386622a483d23557d6b245c6f8dc28f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EmbedWidgetButton_GetCurrentUserQuery$variables = Record<PropertyKey, never>;
export type EmbedWidgetButton_GetCurrentUserQuery$data = {
  readonly currentUser: {
    readonly firms: ReadonlyArray<{
      readonly billingPlan: {
        readonly allowCareerPageIntegration: boolean | null | undefined;
      } | null | undefined;
      readonly legacyBilling: boolean | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type EmbedWidgetButton_GetCurrentUserQuery = {
  response: EmbedWidgetButton_GetCurrentUserQuery$data;
  variables: EmbedWidgetButton_GetCurrentUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "legacyBilling",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowCareerPageIntegration",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmbedWidgetButton_GetCurrentUserQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Firm",
            "kind": "LinkedField",
            "name": "firms",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingPlan",
                "kind": "LinkedField",
                "name": "billingPlan",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EmbedWidgetButton_GetCurrentUserQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Firm",
            "kind": "LinkedField",
            "name": "firms",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingPlan",
                "kind": "LinkedField",
                "name": "billingPlan",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "32f6a593576ff763008e5a70ca1a603f",
    "id": null,
    "metadata": {},
    "name": "EmbedWidgetButton_GetCurrentUserQuery",
    "operationKind": "query",
    "text": "query EmbedWidgetButton_GetCurrentUserQuery {\n  currentUser {\n    firms {\n      legacyBilling\n      billingPlan {\n        allowCareerPageIntegration\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d697ee62842fb369bad465f972383123";

export default node;
